// src/api/landscape.js
import request from "../helper/request";

// 获取风貌照片列表（分页）
export function getLandscapes(params) {
  return request({
    url: "/api/getLandscapes/",
    method: "post",
    data: params
  });
}
export function getAllLandscapes() {
    return request({
      url: '/api/getAllLandscapes/',
      method: 'post',
    });
  }
// 新增风貌照片
export function addLandscape(data) {
  return request({
    url: "/api/addLandscape/",
    method: "post",
    data
  });
}

// 更新风貌照片
export function updateLandscape(data) {
  return request({
    url: "/api/updateLandscape/",
    method: "post",
    data
  });
}

// 删除风貌照片
export function deleteLandscape(data) {
  return request({
    url: "/api/deleteLandscape/",
    method: "post",
    data
  });
}
